import $ from 'jquery';

export default function executeInjectedScripts() {
    var execute = function(scripts) {
        var i,
            count = scripts.length;
        for (i = 0; i < count; i += 1) {
            if (typeof scripts[i] === 'function') {
                scripts[i]($);
            }
        }
    };

    if (Array.isArray(SU.injectedScripts)) {
        execute(SU.injectedScripts);
    }
}
